import request from '@/utils/request'


// 查询商家进件-微信列表
export function listExtraApplyWeixin(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家进件-微信分页
export function pageExtraApplyWeixin(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家进件-微信详细
export function getExtraApplyWeixin(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/detail',
    method: 'get',
    params: data
  })
}

// 新增商家进件-微信
export function addExtraApplyWeixin(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/add',
    method: 'post',
    data: data
  })
}

// 修改商家进件-微信
export function updateExtraApplyWeixin(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/edit',
    method: 'post',
    data: data
  })
}

// 根据对私银行卡号查询开户银行
export function queryWeixinBankByAccount(no) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/bank/account',
    method: 'get',
    params: { no }
  })
}

export function applyExtraApplyWeixin(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/weixin/apply',
    method: 'post',
    data: data
  })
}

